type SkeletonProps = {
  className?: string
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return <div className={`skeleton ${className}`} aria-hidden />
}

type SkeletonListProps = {
  count?: number
  label?: string
}

/** Loading placeholder for list screens — mirrors a list of card rows. */
export function SkeletonList({ count = 3, label = 'Memuat…' }: SkeletonListProps) {
  return (
    <div className="space-y-2" role="status" aria-label={label}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="card flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded-lg shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-3 w-3/4" />
          </div>
        </div>
      ))}
    </div>
  )
}
